import * as React from "react";
import AlignHorizontalRightIcon from "@mui/icons-material/AlignHorizontalRight";
import AlignHorizontalLeftIcon from "@mui/icons-material/AlignHorizontalLeft";
import { useColorMode } from "../context/ColorModeContext";
import { Box, Button, useTheme } from "@mui/material";

export default function RTLSwitch() {
  const { direction, toggleDirection } = useColorMode();
  const theme = useTheme();

  const handleDirectionChange = (newMode: "ltr" | "rtl") => {
    if (direction !== newMode) {
      toggleDirection();
    }
  };

  return (
    <Box sx={{ width: "100%", m: 1 }}>
      <Button
        onClick={() => handleDirectionChange("ltr")}
        variant={theme.direction === "ltr" ? "contained" : "outlined"}
        sx={{
          p: 3,
          mr: 1,
          bgcolor: theme.direction === "ltr" ? "primary.main" : "inherit",
          color: theme.direction === "ltr" ? "common.white" : "inherit",
        }}
      >
        <AlignHorizontalLeftIcon />
      </Button>
      <Button
        onClick={() => handleDirectionChange("rtl")}
        variant={theme.direction === "rtl" ? "contained" : "outlined"}
        sx={{
          p: 3,
          bgcolor: theme.direction === "rtl" ? "primary.main" : "inherit",
          color: theme.direction === "rtl" ? "common.white" : "inherit",
        }}
      >
        <AlignHorizontalRightIcon />
      </Button>
    </Box>
  );
}
